// @flow
import * as React from 'react';
import Box from 'components/Box';
// import usePrevious from 'utils/usePrevious';

const { useState, useEffect } = React;

const defaultEase = x => x ** 4;

const AnimatedCounter = ({
  count,
  from = 0,
  duration = 3000,
  speed = 30,
  ease = defaultEase,
  fixedWidth,
  ...props
}: {
  count: number,
  from?: number,
  duration?: number,
  speed?: number,
  ease?: number => number,
  fixedWidth?: boolean
}) => {
  const [current, setCurrent] = useState(count || 1);

  const steps = (speed * duration) / 1000;

  useEffect(
    () => {
      if (count !== from) {
        const timestamps = new Array(steps)
          .fill()
          .map((_, index) => (ease(index) / ease(steps)) * duration);

        const update = (index = 0) => {
          setTimeout(() => {
            if (index + 1 < timestamps.length) {
              setCurrent(Math.floor(from + ((count - from) * index) / steps));
              update(index + 1);
            } else {
              setCurrent(count);
            }
          }, timestamps[index + 1] - timestamps[index]);
        };
        update();
      }
    },
    [count, duration, ease, from, steps]
  );

  return (
    <Box position="relative" display="inline-block" {...props}>
      {fixedWidth ? (
        <>
          <Box visibility="hidden">{count.toLocaleString(USER_LOCALE)}</Box>
          <Box position="absolute" top={0} right={0} aria-hidden>
            {current.toLocaleString(USER_LOCALE)}
          </Box>
        </>
      ) : (
        current.toLocaleString(USER_LOCALE)
      )}
    </Box>
  );
};

export default AnimatedCounter;
